/* Shopify sorts the complete collection server-side; forms work without JS. */
(() => {
  const init = (scope) => {
    scope.querySelectorAll('[data-fu-pa]').forEach((root) => {
      if (root.dataset.fuInitialized) return;
      root.dataset.fuInitialized = 'true';
      const tools = root.querySelector('[data-fu-parts-tools]');
      const filterCleanups = [];
      if (tools && !tools.hasAttribute('data-fu-unavailable')) {
        const cards = Array.from(root.querySelectorAll('[data-fu-product]'));
        const input = tools.querySelector('[data-fu-parts-search]');
        const categories = tools.querySelector('[data-fu-parts-categories]');
        const counter = root.querySelector('[data-fu-count]');
        const empty = root.querySelector('[data-fu-parts-empty]');
        const normalize = (value) => String(value).normalize('NFKC').toLowerCase().replace(/\u2044/g, '/').replace(/["\u201c\u201d\u2033]/g, '').replace(/o[\s-]?rings?/g, 'oring').replace(/(\d)x(?=\d)/g, '$1 ').replace(/[^a-z0-9/]+/g, ' ').trim();
        const counts = new Map();
        cards.forEach((card) => counts.set(card.dataset.category, (counts.get(card.dataset.category) || 0) + 1));
        const order = ['Fittings', 'Valves & drains', 'Tanks', 'Fridge kits', 'Tools & seals', 'Leak protection'];
        const names = [...order.filter((name) => counts.has(name)), ...Array.from(counts.keys()).filter((name) => !order.includes(name)).sort()];
        const currentUrl = new URL(window.location.href);
        let active = currentUrl.searchParams.get('part_category') || '';
        if (!counts.has(active)) active = '';
        input.value = currentUrl.searchParams.get('part_query') || '';
        const buttons = [];
        categories.textContent = '';
        const apply = (updateUrl = true) => {
          const terms = normalize(input.value).split(' ').filter((term) => term && !['x', 'to', 'inch', 'inches', 'in'].includes(term));
          let visible = 0;
          cards.forEach((card) => {
            const text = normalize(card.dataset.search);
            const match = (!active || card.dataset.category === active) && terms.every((term) => text.includes(term));
            card.hidden = !match;
            if (match) visible++;
          });
          counter.textContent = visible === cards.length ? cards.length + ' parts' : visible + ' of ' + cards.length + ' parts';
          empty.hidden = visible !== 0;
          buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.category === active)));
          if (updateUrl) {
            const url = new URL(window.location.href);
            if (input.value.trim()) url.searchParams.set('part_query', input.value.trim());
            else url.searchParams.delete('part_query');
            if (active) url.searchParams.set('part_category', active);
            else url.searchParams.delete('part_category');
            window.history.replaceState(null, '', url);
          }
        };
        ['', ...names].forEach((name) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.category = name;
          button.textContent = name ? name + ' (' + counts.get(name) + ')' : 'All parts (' + cards.length + ')';
          const selectCategory = () => { active = name; apply(); };
          button.addEventListener('click', selectCategory);
          filterCleanups.push(() => button.removeEventListener('click', selectCategory));
          categories.append(button);
          buttons.push(button);
        });
        const onInput = () => apply();
        input.addEventListener('input', onInput);
        filterCleanups.push(() => input.removeEventListener('input', onInput));
        root.querySelectorAll('[data-fu-parts-clear]').forEach((button) => {
          const clear = () => { input.value = ''; active = ''; apply(); input.focus(); };
          button.addEventListener('click', clear);
          filterCleanups.push(() => button.removeEventListener('click', clear));
        });
        tools.hidden = false;
        apply(false);
      }
      const form = root.querySelector('[data-fu-sort-form]');
      const select = form?.querySelector('[data-fu-sort]');
      const onChange = () => form.requestSubmit();
      const onSubmit = (event) => {
        if (event.defaultPrevented) return;
        event.preventDefault();
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        url.hash = root.querySelector('[data-fu-catalogue]').id;
        window.location.assign(url.toString());
      };
      if (select) {
        select.addEventListener('change', onChange);
        form.addEventListener('submit', onSubmit);
      }
      const variantChanges = [];
      root.querySelectorAll('[data-fu-variant]').forEach((picker) => {
        const card = picker.closest('[data-fu-quick-card]');
        const onVariant = () => {
          const option = picker.selectedOptions[0];
          if (!option || !card) return;
          card.querySelector('[data-fu-price]').textContent = option.dataset.price;
          card.dataset.price = option.dataset.priceValue;
          const sku = card.querySelector('[data-fu-sku]');
          if (sku) sku.textContent = option.dataset.sku;
          card.querySelector('[data-fu-part-title]').textContent = option.dataset.cardTitle;
          const compare = card.querySelector('[data-fu-compare]');
          compare.hidden = !option.dataset.compare;
          card.querySelector('[data-fu-compare-value]').textContent = option.dataset.compare || '';
          const button = card.querySelector('[data-fu-add]');
          button.disabled = option.disabled;
          button.setAttribute('aria-label', 'Add ' + option.dataset.cardTitle + ' to cart');
          const url = new URL(card.dataset.productUrl, window.location.origin);
          url.searchParams.set('variant', option.value);
          card.querySelectorAll('[data-fu-part-link]').forEach((link) => {
            link.href = url.toString();
            if (link.hasAttribute('aria-label')) link.setAttribute('aria-label', option.dataset.cardTitle);
          });
        };
        picker.addEventListener('change', onVariant);
        variantChanges.push(() => picker.removeEventListener('change', onVariant));
      });
      const grid = root.querySelector('[data-fu-catalogue]');
      const bar = root.querySelector('[data-fu-mobile-shop]');
      let observer;
      if (grid && bar && 'IntersectionObserver' in window) {
        observer = new IntersectionObserver(([entry]) => { bar.hidden = entry.isIntersecting; }, { threshold: 0 });
        observer.observe(grid);
      }
      root.fuCleanup = () => {
        observer?.disconnect();
        filterCleanups.forEach((cleanup) => cleanup());
        variantChanges.forEach((cleanup) => cleanup());
        select?.removeEventListener('change', onChange);
        form?.removeEventListener('submit', onSubmit);
        delete root.dataset.fuInitialized;
      };
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-fu-pa]').forEach((root) => root.fuCleanup?.());
  });
})();
